import { useState } from 'react';

import ContinueButton from '@/shared-components/buttons/components/ContinueButton'; // Import ContinueButton
import OrderCard from '@/shared-components/cards/components/OrderCard';
import OrderShippingCard from '@/shared-components/cards/components/OrderShippingCard';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import ReportIssueForm from './report-issue-form';

import './index.css';

function ReportIssueContent({ orderData, onReportIssue }) {
  const [didReceiveArtwork, setDidReceiveArtwork] = useState("");

  return (
    <>
      <OrderCard orderData={orderData} />

      <OrderShippingCard shippingData={orderData.order_shipping_address} />

      {/* Use Text component and ensure the text is centered */}
      <Text className="report-issue__text">
        Did you receive the artwork?
      </Text>

      {/* Replace spans with ContinueButtons using the "continue-button_two" class */}
      <div className="report-issue__buttons">
        <ContinueButton
          onClick={() => setDidReceiveArtwork(true)}
          className={`report-issue__button continue-button_two ${didReceiveArtwork === true ? "active" : ""}`}
        >
          Yes
        </ContinueButton>

        <ContinueButton
          onClick={() => setDidReceiveArtwork(false)}
          className={`report-issue__button continue-button_two ${didReceiveArtwork === false ? "active" : ""}`}
        >
          No
        </ContinueButton>
      </div>

      <ReportIssueForm
        orderData={orderData}
        onReportIssue={onReportIssue}
        didReceiveArtwork={didReceiveArtwork}
      />
    </>
  );
}

export default function ReportIssue({ open, close, orderData, onReportIssue }) {
  return (
    <>
      <GenericPopup
        className="report-issue-popup"
        open={open}
        opacity
      >
        <div className="generic-popup-header report-issue-header">
          <span className="generic-popup-header-text">
            Report an issue
          </span>
          <XIcon className="generic-popup-close" onClick={close} />
        </div>

        <ReportIssueContent 
          orderData={orderData} 
          onReportIssue={(orderId, issueData) => { onReportIssue(orderId, issueData); close(); }} 
        />
      </GenericPopup>
    </>
  );
}
